module.exports = __webpack_public_path__ + "static/img/A47.e0ad3a68.jpg";